import type { ComponentType } from 'react';
import type { StepProps } from '../engine/context.ts';
import type { StepType } from '../engine/types.ts';
import { Hook } from './Hook.tsx';
import { MultiSelect, TapSelect } from './TapSelect.tsx';
import { Slider } from './Slider.tsx';
import { SwipeCards } from './SwipeCards.tsx';
import { DragRank } from './DragRank.tsx';
import { BeforeAfter } from './BeforeAfter.tsx';
import { TapFrame } from './TapFrame.tsx';
import { HoldReveal } from './HoldReveal.tsx';
import { Interstitial } from './Interstitial.tsx';
import { Loader } from './Loader.tsx';
import { Projection } from './Projection.tsx';
import { ArchetypeStep } from './Archetype.tsx';
import { SocialProof } from './SocialProof.tsx';
import { Email } from './Email.tsx';
import { PlanPage } from './PlanPage.tsx';
import { CheckoutHandoff } from './CheckoutHandoff.tsx';

/** Adding a step of an existing type is a JSON change; a new type registers here. */
export const StepRegistry: Record<StepType, ComponentType<StepProps>> = {
  hook: Hook,
  'tap-select': TapSelect,
  'multi-select': MultiSelect,
  slider: Slider,
  'swipe-cards': SwipeCards,
  'drag-rank': DragRank,
  'before-after-divider': BeforeAfter,
  'tap-frame': TapFrame,
  'hold-reveal': HoldReveal,
  interstitial: Interstitial,
  loader: Loader,
  projection: Projection,
  archetype: ArchetypeStep,
  'social-proof': SocialProof,
  email: Email,
  'plan-page': PlanPage,
  'checkout-handoff': CheckoutHandoff,
};

/** the `mechanic` tracking param: the type, or the variant when there is one */
export function mechanic(type: StepType, variant?: string, kind?: string): string {
  if (variant === 'two-up' || variant === 'video') return variant;
  if (type === 'slider' && kind === 'agree') return 'agree';
  return type;
}
